<template>
  <div class="rc-view press pt-4">
    <v-container class="rc-padding fluid" >

      <div v-if="canShow">
        <v-layout wrap row align-center justify-center>
          <v-flex xs12 md12 px-3 class="text-xs-left">
            <h1 class="rc-tituloSection">Prensa</h1>
          </v-flex>
        </v-layout>
        <v-layout wrap row>
          <v-tabs
            v-model="active"
            slider-color="#FF8A00"
            style="width: 100%; margin-bottom: 20px; "
            ref="tabsContainer"
            class="tabs-container"
          >
            <v-tab
              v-for="(tab, index) in tabs"
              :key="tab.value"
              :ref="tab.active ? 'activeTab' : null"
              active-class="active__color"
              exact-active-class="active__color"
              style="display: inline-block; min-width: max-content;"
              @click="setActive(index)"
            >
              {{ tab.name }}
  
            </v-tab>
            <v-tab-item
              v-for="item in tabs"
              :key="item.value"
            >
              <v-card flat>
                <v-layout wrap row align-start justify-start>
                  <v-flex xs12>
                    <div class="filter_list" >
                        <v-chip
                          v-for="(item, index) in filtersMedio" :key="`${item.slug}-${index}`"
                          outline
                          class="filter__chip"
                          :class="{ 'active': item.filter }"
                          @click="filterSection(item.slug)"
                        >
                        
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            v-if="item.icon !== ''"
                          >
                            <path :d="item.icon"></path>
                          </svg>
                          <span>
                            {{ item.medio }}
                          </span>
                        </v-chip>
                        <v-chip
                          outline
                          class="filter__clean"
                           v-if="filtersMedio.some(f => f.filter)"
                          @click="clearFilters"
                        >
                          <span>Limpiar filtros</span>
                        </v-chip>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout
                      wrap row
                      class="cards__container"
                        >
                      <template v-if="filteredData.length > 0">
                        <v-flex
                          v-for="(post, index) in filteredData"
                          :key="`${post.url}-${index}`"
                        >
                          <PressCard :post="post" :medios="filtersMedio" />
                        </v-flex>
                      </template>
                      <template v-else>
                        <v-flex xs12 class="text-center">
                          <h2>No se encontraron coincidencias.</h2>
                        </v-flex>
                      </template>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-layout>
      </div>
      <div v-else>
        <ShowLoading tituloLoading="Cargando..." />
      </div>
    </v-container>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { RedCapital, SelectedCountry, TitleTemplatePublic } from '@/configuration'
import PressCard from '@/components/NewPressCard.vue'
import API from '@/api';
import ShowLoading from "@/components/panel/ShowLoading.vue";
import { iconsBySlug } from '@/models/Icons';

@Component({
  metaInfo: {
    title: 'Prensa',
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    }
  },
  components: {
    PressCard,
    ShowLoading
  },
  data() {
    return{
      press: [],
      tabs: [],
      active: 0,
      filtersMedio: [],
      news: {},
      isFirstTime: true,
      canShow: false,
    }
  },
  async beforeMount() {
		await this.buildData();
	},
  methods: {
    buildArrayByYear(year){
      return this.press
        .filter(el => el.year == year)
        .slice()
        .sort(this.byDateDesc);
    },
    buildArrayByFavorites(){
      return this.press
        .filter(el => el.favorite === true)
        .slice()
        .sort(this.byDateDesc);
    },
    buildArrayByRange(){
      return this.press
        .filter(el => el.year >= 2016 && el.year <= 2019)
        .slice()
        .sort(this.byDateDesc);
    },
    buildArrayByFilter(value){
      if (value === 'favorites') return this.buildArrayByFavorites();
      if (value === 'all') return this.press.slice().sort(this.byDateDesc);

      if (typeof value === 'string' && value.startsWith('range_')) {
        const [from, to] = value.replace('range_', '').split('_').map(Number); // ej: range_2019_2016
        return this.press
          .filter(el => el.year >= to && el.year <= from)
          .slice()
          .sort(this.byDateDesc);
      }

      return this.press
        .filter(el => el.year === Number(value))
        .slice()
        .sort(this.byDateDesc);
    },
    buildData : async function (){
      try {
        this.canShow = false;
        const { data } = await API.getPrensa();
        this.press = data.prensa;
        this.tabs = [
          { name: 'Destacados', value: 'favorites', active: true },
          { name: 'Todo prensa', value: 'all', active: false },
          ...data.filtros.map(f => ({
            name: f.label,
            value: f.value,
            active: false
          }))
        ];

        this.tabs.forEach(tab => {
          this.news[tab.value] = this.buildArrayByFilter(tab.value);
        });

        this.filtersMedio = (data.medios || []).map(m => ({
          filter: false,
          medio: m.medio,
          slug: m.slug,
          icon: iconsBySlug[m.slug] || ''
        }));

      } catch (error) {
        this.press = [];
        this.tabs = []; 
        this.news = {};
        this.filtersMedio = [];
      }
      finally {
        this.canShow = true;
      }
    },
    filterSection(slug){
      const filterItem = this.filtersMedio.find(el => el.slug === slug);
      filterItem.filter = !filterItem.filter;
    },
    clearFilters(){
      this.filtersMedio.forEach(el => el.filter = false);
    },
    setActive(index) {
      this.tabs = this.tabs.map((tab, i) => ({
        ...tab,
        active: i === index
      }));
      this.active = index;
      this.centerActiveTab();
      this.clearFilters();
    },
    centerActiveTab() {
      this.$nextTick(() => {
        const container = document.getElementsByClassName('v-tabs__container')[0];
        const activeTab = this.$refs.activeTab;
        if (container && activeTab) {
          const containerWidth = container.offsetWidth;
          const tabLeft = activeTab[0].$el.offsetLeft;
          const tabWidth = activeTab[0].$el.offsetWidth;
          const scrollPosition = tabLeft - (containerWidth / 2) + (tabWidth / 2);
          
          container.scrollLeft = scrollPosition;
        }
      });
    },
    toDate(d) {
      if (!d) return new Date(0);
      if (typeof d === 'string') {
        const parts = d.split('-');
        if (parts.length === 3 && parts[0].length === 2) {
          return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        }
        return new Date(d);
      }
      return new Date(d);
    },
    byDateDesc(a, b) {
      return this.toDate(b.date) - this.toDate(a.date);
    },

	},
	computed: {
    filteredData() {
      const active =  this.tabs[this.active].value;
      let filteredByFilters = this.news[active];
      
      const activeFilters = this.filtersMedio.filter(el => el.filter).map(el => el.slug);
  
      if (activeFilters.length > 0) {
        filteredByFilters = this.news[active]
          .filter(item => item.medio && activeFilters.includes(item.medio))
          .sort((a, b) => new Date(b.date.split('-').reverse().join('-')) - new Date(a.date.split('-').reverse().join('-')));
      } 

      return filteredByFilters;
    },
	},

})
export default class Press extends Vue {}
</script>

<style lang="scss" >
.filter_list{
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 0;
  margin: 20px 0;
}

.v-tabs__div{
  background: transparent !important;
}
.active__color{
  color: #FF8A00 !important;
}
.v-chip.v-chip.v-chip--outline.theme--light.filter__chip{
  border-radius: 5px !important;
  border: 1px solid #8b8b8b !important;
  display: inline-flex;
  flex-direction: row;
  align-items: center;

  span{
    margin-left: 5px;
  }

  &:hover{
    &.active{
      background-color: #fff !important;
    }

    border-color: #FF8A00 !important;
    span{
      color: #FF8A00 !important;
    }
  }

  &.active{
    background-color: #FF8A00 !important;
    color: #fff !important;
    border-color: #FF8A00 !important;

    &::after{
      content: none !important;
      box-shadow: none !important;
    }
  }
  
  &:after{
    content: none !important;
    box-shadow: none !important;
  }

} 

.rc__custom-input{
    .v-input__control{
        .v-input__slot{     
            border-radius: 12px !important;
        }
    }    
    
}
.rc-card{
  margin: 20px 0px;
}
.rc-card-title{

  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0 !important;
  margin-bottom: 16px;

  span{
    font-size: 1.5rem;
    font-weight: 600;
    color: #FF8A00 !important;
  }

  .title-img{
    width: 58px;
    height: 58px;
    margin-right: 1rem;
  }
}

.v-expansion-panel{
  box-shadow: none !important;
}
table.info__table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    border: 1px solid #3d3d3d;
    padding: 8px;
    text-align: left;
  }
}

.title-section:hover{
  color: #FF8A00 !important
}
.v-expansion-panel__container.v-expansion-panel__container--active{
  .title-section{
    color: #FF8A00 !important;
  }

}
.v-expansion-panel__container--active > .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{
  transform: rotate(-45deg) !important;
}


.v-chip.v-chip.v-chip--outline.theme--light.filter__clean{
  border-radius: 5px !important;
  border: 1px solid #FF8A00 !important;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  color: #FF8A00 !important;

  span{
    margin-left: 5px;
  }

  &:hover{
    border-color: #FF8A00 !important;
    background-color: #FFF3E2 !important;
    span{
      color: #FF8A00 !important;
    }
  }
  
  &:after{
    content: none !important;
    box-shadow: none !important;
  }

}
.v-tabs__container {
  overflow-x: auto !important;
}
.cards__container{
  display: grid; 
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); 
  gap: 10px;
  justify-items: center;
}


@media (max-width: 1440px) {
  .cards__container{
    gap: 10px !important; 
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .cards__container{
    gap: 10px !important; 
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

@media (max-width: 400px) {
  .cards__container{
    gap: 15px 0px !important; 
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

.v-tabs__container {
  scrollbar-width: thin;             
  scrollbar-color: transparent transparent; 
}

.v-tabs__container::-webkit-scrollbar {
  height: 3px;      
}
.v-tabs__container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
.v-tabs__container::-webkit-scrollbar-thumb {
  background-color: transparent; 
  border-radius: 4px;
}

.v-tabs__container::-webkit-scrollbar-thumb:hover {
  background-color: transparent; 
}
</style>
